// Firebase's own floor is 6 characters with no complexity requirement —
// deliberately stricter here since that minimum is weak enough to be
// trivially brute-forced offline if a credential database ever leaked.
export const MIN_PASSWORD_LENGTH = 8;

export function getPasswordRequirements(password) {
  return {
    length: password.length >= MIN_PASSWORD_LENGTH,
    letter: /[a-zA-Z]/.test(password),
    number: /[0-9]/.test(password),
  };
}

export function isPasswordValid(password) {
  const req = getPasswordRequirements(password);
  return req.length && req.letter && req.number;
}

// 0-4 scale purely for the visual meter — not itself a validity check.
export function getPasswordScore(password) {
  if (!password) return 0;
  const req = getPasswordRequirements(password);
  let score = [req.length, req.letter, req.number].filter(Boolean).length;
  if (password.length >= 12) score += 1;
  return Math.min(score, 4);
}
